var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telephone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.93 35.34c-.39-1.71-1.08-1.71-8.76-5.55a2.85 2.85 0 0 0 -3.29.54l-4.41 4.47a34.8 34.8 0 0 1 -10.89-7.38 37.35 37.35 0 0 1 -7.4-10.81l4.49-4.49a2.85 2.85 0 0 0 .54-3.29c-3.85-7.69-3.83-8.37-5.55-8.76s-1.9.16-10.13 6.56a6.58 6.58 0 0 0 -2.53 5.37 37.47 37.47 0 0 0 36 36 6.57 6.57 0 0 0 5.4-2.53c6.28-8.11 6.93-8.37 6.53-10.13zm-36.42-33.16a.85.85 0 0 1 1.28.29c3.89 7.78 4.06 7.64 3.47 8.24l-2 2-4.57-9.12zm28.28 42.06a4.57 4.57 0 0 1 -3.79 1.76 35.45 35.45 0 0 1 -34-34 4.57 4.57 0 0 1 1.76-3.79l4.32-3.37 4.69 9.36c-.87.86-2 1.71-1.39 3.15a36.73 36.73 0 0 0 19.27 19.27c1.45.66 2.31-.55 3.15-1.39l9.36 4.69zm4.62-5.93-9.12-4.57 2-2a.87.87 0 0 1 1-.16c7.91 4 7.58 3.66 7.7 4.2s-.11.64-1.58 2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 5a16 16 0 0 1 16 16 1 1 0 0 0 2 0 18 18 0 0 0 -18-18 1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 11a10 10 0 0 1 10 10 1 1 0 0 0 2 0 12 12 0 0 0 -12-12 1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 17a4 4 0 0 1 4 4 1 1 0 0 0 1 1c2.42 0 .5-7-5-7a1 1 0 0 0 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.0441424c96383983abf4eaf2f4dcc87d.svg";
export { ForwardRef as ReactComponent };